import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import InAppBrowserBanner from './components/InAppBrowserBanner';
import HomePage from './pages/HomePage';
import PreviousWork from './pages/PreviousWork';
import QuoteRequest from './pages/QuoteRequest';
import Login from './pages/Login';
import AdminLogin from './pages/AdminLogin';
import { ClientDashboard, MessagesPage, InvoicesPage } from './pages/ClientDashboard';
import { AdminDashboard, AdminJobs, AdminMessages, AdminClients } from './pages/AdminDashboard';
import AdminInvoices from './pages/AdminInvoices';
import AdminExpenses from './pages/AdminExpenses';
import AdminReminders from './pages/AdminReminders';
import PaymentPage from './pages/PaymentPage';
import PaymentSuccess from './pages/PaymentSuccess';
import './index.css';

function PrivateRoute({ children }) {
  const { currentUser, loading } = useAuth();
  if (loading) return null;
  return currentUser ? children : <Navigate to="/login" />;
}

function AdminRoute({ children }) {
  const { currentUser, isAdmin, loading } = useAuth();
  if (loading) return null;
  if (!currentUser) return <Navigate to="/admin" />;
  if (!isAdmin) return <Navigate to="/" />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/work" element={<PreviousWork />} />
      <Route path="/quote" element={<QuoteRequest />} />
      <Route path="/login" element={<Login />} />
      <Route path="/finishSignIn" element={<Login />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/dashboard" element={<PrivateRoute><ClientDashboard /></PrivateRoute>} />
      <Route path="/messages" element={<PrivateRoute><MessagesPage /></PrivateRoute>} />
      <Route path="/invoices" element={<PrivateRoute><InvoicesPage /></PrivateRoute>} />
      <Route path="/pay/:invoiceId" element={<PrivateRoute><PaymentPage /></PrivateRoute>} />
      <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/jobs" element={<AdminRoute><AdminJobs /></AdminRoute>} />
      <Route path="/admin/messages" element={<AdminRoute><AdminMessages /></AdminRoute>} />
      <Route path="/admin/clients" element={<AdminRoute><AdminClients /></AdminRoute>} />
      <Route path="/admin/invoices" element={<AdminRoute><AdminInvoices /></AdminRoute>} />
      <Route path="/admin/expenses" element={<AdminRoute><AdminExpenses /></AdminRoute>} />
      <Route path="/admin/reminders" element={<AdminRoute><AdminReminders /></AdminRoute>} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <InAppBrowserBanner />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
